import { Component, inject, Injector, OnInit, viewChild } from '@angular/core';
import {
  idNameItem,
  JkBaseOption,
  JkComboboxComponent,
  JkdatefieldComponent,
  login,
  LoginService,
  OrmService,
  PageKind,
} from 'jk-service';
import { MaterialModule } from 'jk-service';
import { ChartType } from 'ng-apexcharts';
import { AdvComModule, jkQueryComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { JkmultiselectComponent } from 'jk-advcom';
import { JkheatmapComponent } from '../components/jkheatmap/jkheatmap.component';

export class PageOption extends JkBaseOption { // ###
  constructor(name: string) {// ###
    super(name);
  }
}
export const chartTypeList: idNameItem[] = [
  { id: 'heatmap', name: '熱力圖' },
  { id: 'treemap', name: '樹狀圖' },
];

class FilterOption extends JkBaseOption {
  date: string = '';
  frequency: string = '日線'; // 資料頻率
  stkme001: idNameItem[] = [];
  chartType: ChartType = 'treemap';
  orderBy: string = '';
  dataFrom: string = 'stkme';
  //orm: OrmService= inject(OrmService);
  //login: LoginService; = inject(LoginService);
  constructor(programId: string) {
    super(programId);
    const sql = `SELECT TOP 1 LG001 FROM STKLG ORDER BY LG001 DESC `;
    this.orm.simpleSql(login.host, sql).subscribe((data: any) => {
      this.date = data[0].LG001;
      this.cdr.markForCheck();
    });
  }
  override init() {
    super.init();
  }
}

@Component({
  selector: 'app-stkpq15',
  standalone: true,
  imports: [
    JackBaseComponentModule,
    MaterialModule,
    AdvComModule,
    JkheatmapComponent,
    // JktreemapComponent,
  ],
  templateUrl: './stkpq15.component.html',
  styleUrl: './stkpq15.component.css',
})
export class Stkpq15Component extends jkQueryComponent implements OnInit {
  override _programId = 'stkpq15'; // ###
  pageOpt: PageOption = new PageOption(this.programId + '_page'); //###
  filterOpt: FilterOption = new FilterOption(this.programId); //###
  chartTypeList: idNameItem[] = chartTypeList;
  readonly stkme001Com = viewChild.required<JkmultiselectComponent>('stkme001Com'); // 群組代號
  readonly stklg001Com = viewChild.required<JkdatefieldComponent>('stklg001Com'); // 日期
  readonly charttype = viewChild.required<JkComboboxComponent>('charttype'); // 圖表類型
  readonly heatmap = viewChild.required<JkheatmapComponent>('heatmap'); // 熱力圖
  stkmeList: idNameItem[] = [];
  dataFromList: idNameItem[] = [{ id: 'stkme', name: '群組' }, { id: 'stktm', name: '追蹤中心' }];
  constructor() {
    super();
    this.setFormOpt2(); //###

    this.logMessage = '';
    //this.addOpenwinLoadOption('#STKME', 'W01', 'W', [], this.stkmeList);
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  override getLookup(): void {
    super.getLookup();
    this.orm.doOpenWin_get('S', 'STKME', 'S03', []).subscribe((data: any) => {
      if (data.result) this.stkmeList = data.obj;
      //if (this.stkmeList.length > 0)
      //this.filterOpt.stkme001 = this.stkmeList[0].id;
      //this.stkme001Change(this.stkme001);
      this.cdr.markForCheck();
    });
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.updateStkme001();
  }
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    /* {'id':'ORDER BY MM004 DESC,MM003,MM002','name':'依日期倒序+股票代號+條件代號'},
  {'id':'ORDER BY MM003,MM004 DESC,MM002','name':'依股票代號+日期倒序+條件代號'},
  {'id':'ORDER BY MM002,MM003,MM004 DESC','name':'依條件代號+股票代號+日期倒序'},*/
    this.winItem = 'S01';

    this.gridInitOpt = {
      pageKind: PageKind.report,
      programId: this.programId,
      sortField: 'ME001',
      sort: 'asc',
      defaultSort: null,
    };
    this.type = 'S';
    this.mainTable = this.programId; //['LG001','LG002','LG003','LG004'];
    this.where = '';
    this.where = this.stkme001Com().addWhere(this.where, 'MF001');
    this.where = this.stklg001Com().addWhere(this.where, 'LG001');
    this.order = this.filterOpt.orderBy;
    this.refreshMap();
    return true;
  }
  // 以下為自訂的方法
  refreshMap() {
    //this.heatmap.groupList = jkLib.idNameItem2String(this.filterOpt.stkme001);
    //this.heatmap.refresh();
  }
  updateStkme001() {
    //this.filterOpt.stkme001 = [];
    let sql = `SELECT ME001 as id,ME002 as name,ME004
FROM STKME
LEFT JOIN STKMF ON MF001=ME001
WHERE ME013='Y' AND MF001 IS NOT NULL
GROUP BY ME001,ME002,ME004
ORDER BY ME004 `;
    this.orm.simpleSql(this.host, sql).subscribe((data) => {
      //this.filterOpt.stkme001.push(...data);
      //this.stkme001Com.values = data;
      this.filterOpt.stkme001 = data;
      //console.log(this.filterOpt.stkme001);
      // data.forEach((ds: any) => {
      //   let item = { id: ds.ME001, name: ds.ME002 };
      //   this.filterOpt.stkme001.push(item);
      // });
      this.cdr.markForCheck();
    });
  }
}
